import { OrderState } from '@/constant';
import cx from './index.module.scss';

const OrderStateComp = ({ state }: { state: Service.OrderState }) => {
  return <div className={cx('state', state.toLowerCase())}>{OrderState[state]}</div>;
};

export default OrderStateComp;
